import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import RoleGate from './RoleGate';
import Layout from './Layout/Layout';

// Public
import Login from './register/Login';
import Register from './register/Registration';
import InfoPage from './LandingPageLayout/InfoPage';
import footerPages from './LandingPageLayout/footerPages';

// Admin/Common
import Dashboard from './dashboard';
import AddBookType from "./components/Add_Book_Type/AddBookType";
import AddNewBook from "./components/Add_New_Book/AddNewBook";
import BookList from "./components/Book_List/BookList";
import IssueBook from "./components/Issue_Book/IssueBook";
import IssuedBookList from './components/Issued_Book_List/IssuedBookList';
import IssueBookForStaff from './components/Issue_Book_Staff/IssueBookStaff';
import IssuedBookForStaffList from './components/Issued_Book_List_Staff/IssuedBookListStaff';
import AddLibrary from './components/Library_List/LibraryList';
import TransactionBookList from './components/Transaction_Book_List/TransactionBookList';
import DiscardedBookList from './components/Discarded_Book_List/DiscardedBookList';
import BooksBarcode from './components/Books_Barcode/BooksBarcode';
import SpineLabel from './components/Spine_Label/SpineLabel';
import AddNewspaper from './components/Add_Newspaper/AddNewspaper';
import BookRecord from './components/Book_Record/BookRecord';
import BookNameList from "./components/New_Arrivals/NewArrivals";
import NewArrivals from "./components/New_Arrivals/NewArrivals";
import NewspaperRegister from './components/Newspaper_Register/NewspaperRegister';
import PeriodicalManagement from './components/Periodical_Management/PeriodicalManagement';
import MembersHistory from './components/History_of_Members/MembersHistory';
import AddAnnouncement from './components/AddAnnouncement/AddAnnouncement';
import AnnouncementList from './components/AddAnnouncement/AnnouncementList';
import AddUserPage from './components/Add_User/Add_User';
import Card from './components/LibraryCard/Cards'
import AllLibraryCardList from './components/LibraryCard/LibraryCard'
import Home from './LandingPageLayout/Home';

// Parent

import { parentRoutes } from './Parents/parentRoutes';


// Librarian
import { librarianRoutes } from './Librarian/librarianRoutes';

// Admin (Super Admin: aggregate dashboard, reused librarian pages under /admin,
// plus admin-only Schools/Roles/Users screens)
import { adminRoutes } from './Admin/adminRoutes';

// School Admin (role 2): reused librarian pages under /school scoped to their
// own school, plus a school dashboard, My School and staff management
import { schoolRoutes } from './School/schoolRoutes';

const AppRoutes = () => {
  return (
    <Routes>
      {/* 🌐 Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* 📄 Public footer info pages */}
      {footerPages.map((page) => (
        <Route
          key={page.slug}
          path={`/${page.slug}`}
          element={<InfoPage slug={page.slug} />}
        />
      ))}

      {/* 🔐 Private Routes under Layout */}
      <Route
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* 🧑‍💼 Admin/Common Routes — legacy/staff-context pages, not linked
            from any nav menu but still reachable by URL. Role-gated to any
            staff role (Admin/School/Librarian/Assistant Librarian) so a
            Parent session can't open them just by typing the path. */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route element={<RoleGate allow={[1, 2, 3, 4]}><Outlet /></RoleGate>}>
          <Route path="/add-book-type" element={<AddBookType />} />
          <Route path="/add-new-book" element={<AddNewBook />} />
          <Route path="/book-list" element={<BookList />} />
          <Route path="/issue-book" element={<IssueBook />} />
          <Route path="/issued-book-list" element={<IssuedBookList />} />
          <Route path="/issue-book-for-staff" element={<IssueBookForStaff />} />
          <Route path="/issued-book-for-staff-list" element={<IssuedBookForStaffList />} />
          <Route path="/library-list" element={<AddLibrary />} />
          <Route path="/transaction-book-list" element={<TransactionBookList />} />
          <Route path="/discarded-book-list" element={<DiscardedBookList />} />
          <Route path="/books-barcode" element={<BooksBarcode />} />
          <Route path="/spine-label" element={<SpineLabel />} />
          <Route path="/book-record" element={<BookRecord />} />
          <Route path="/book-name-list" element={<BookNameList />} />
          <Route path="/new-arrivals" element={<NewArrivals />} />
          <Route path="/add-newspaper" element={<AddNewspaper />} />
          <Route path="/newspaper-register" element={<NewspaperRegister />} />
          <Route path="/periodical-management" element={<PeriodicalManagement />} />
          <Route path="/members-history" element={<MembersHistory />} />
          <Route path="/add-announcement" element={<AddAnnouncement />} />
          <Route path="/announcements" element={<AnnouncementList />} />
          <Route path="/add-users" element={<AddUserPage/>} />
          <Route path="/library-card" element={<AllLibraryCardList />} />
          <Route path="/library-cards/:id" element={<Card />} />
        </Route>

        {/* 👪 Parent Routes */}
       {parentRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RoleGate allow={[1, 5]}>{route.element}</RoleGate>}
          />
        ))}

        {/* 📚 Librarian Routes */}
        {librarianRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RoleGate allow={[1, 3]}>{route.element}</RoleGate>}
          />
        ))}

        {/* 🛡️ Admin Routes (Super Admin) — reused librarian pages under /admin
            plus admin-only Schools / Roles / Users screens */}
        {adminRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RoleGate allow={[1]}>{route.element}</RoleGate>}
          />
        ))}

        {/* 🏫 School Admin Routes (role 2) — reused librarian pages under /school
            scoped to their own school, plus School dashboard / My School / staff */}
        {schoolRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RoleGate allow={[1, 2]}>{route.element}</RoleGate>}
          />
        ))}

      </Route>
    </Routes>
  );
};

export default AppRoutes;
